import status from "../constants/actionStatus";

const getUserCourseReducer = (
    state = {
        courses: {},
        isLoading: false,
        error: null,
    },
    action = {}
) => {
    switch (action.type) {
    case "USER_COURSE_REQUEST":
        return {
            ...state,
            status: status.PENDING,
            courses: {},
            isLoading: true,
            error: null,
        };
    case "USER_COURSE_SUCCESS":
        return {
            ...state,
            status: status.SUCCESS,
            courses: action.payload,
            data: action.skip === 0 ? action.payload.data?.[0]?.courses : [...(state.data?.[0]?.courses || []), ...action.payload.data?.[0]?.courses],
            totalCount: action.payload.totalCount,
            isLoading: false,
        };

    case "USER_COURSE_FAILURE":
        return {
            ...state,
            status: status.ERROR,
            courses: {},
            isLoading: false,
            error: action.payload,
        };
    default:
        return state;
    }
};

export default getUserCourseReducer;
